module.exports = "<div ng-if=\"$ctrl.authService.user && $ctrl.authService.isLoggedIn()\"><dashboard-sidebar on-toggle=$ctrl.onSidebarToggle($event) items=$ctrl.sidebarItems balance=$ctrl.balance user=$ctrl.user get-counter=$ctrl.getCounter></dashboard-sidebar><dashboard-topbar user=$ctrl.user balance=$ctrl.balance></dashboard-topbar><main class=main ng-class=\"{'small-content': !$ctrl.isSidebarOpened}\"><div class=content ui-view></div></main></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states/dashboard/dashboard.component.html
// module id = 901
// module chunks = 31